// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_kh-0";